<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ title | translate }}
  </h4>
  @if (showCloseButton) {
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()">
    </button>
  }
</div>
<div class="modal-body p-3">
  <div id="scrollBox" class="customScrollbar" (scroll)="onScroll($event)">
    @if (pageId) {
      <app-cms-page-content
        class="d-inline-block"
        [pageId]="pageId"
        (contentLoaded)="checkScrollPosition()"
      ></app-cms-page-content>
    }
  </div>

</div>
@if (!signed) {
  <div class="modal-footer">
    <span class="d-flex justify-content-between items-center col-md-12 p-0">
      <button
        class="btn btn-success btn-lg "
        [disabled]="loading"
        (click)="submit()"
        >
        {{ "ACCEPT" | translate }}
      </button>
      @if (showCloseButton) {
        <button
          class="btn btn-dark btn-lg  me-2"
          [disabled]="loading"
          (click)="closeModal()"
          >
          {{ "REJECT" | translate }}
        </button>
      }
    </span>
  </div>
}
